// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment} from 'react';
import {Button} from '../ui/button';
import {Text_input} from '../ui/input';
import {Textarea} from '../../hola/pub/lib/textarea';
import {Checkbox} from '../../hola/pub/lib/checkbox';
import {Title_header_select} from './title_header_select';

import styles from './editor.module.less';

type editor_type = 'text' | 'textarea' | 'number' | 'boolean'
  | 'selector' | 'color' | 'select_tag_selector';
interface i_editor_field<t> {
  key: keyof t;
  label: string;
  type: editor_type;
  options?: { value: string; label: string }[];
}
interface i_editor_props<T> {
    value: T;
    editors: i_editor_field<T>[];
    children?: React.ReactNode;
    title?: React.ReactNode;
    on_change: (v:T)=>void;
    on_remove?: (v:T)=>void;
    on_save?: ()=>void;
    on_cancel?: ()=>void;
}
export const Editor = <T, >(props: i_editor_props<T>)=>{
    const {value, editors, on_change, on_remove, on_cancel, on_save} = props;
    const handle_change = (key: keyof T, v: any)=>{
        on_change({...props.value, [key]: v});
    };
    return <div className={styles.editor}>
      {props.title && <div className={styles.title}>{props.title}</div>}
      <div className={styles.form}>
        {editors.map(({key, label, type, options})=>
          <div key={String(key)} className={styles.editor_field}>
            <label>{label}</label>
            {type === 'text' &&
              <Text_input
                value={(value[key]||'')+''}
                on_change={v=>handle_change(key, v)} />
            }
            {type === 'select_tag_selector' &&
              <Title_header_select value={(value[key]||'')+''} on_select={v=>
                on_change({...value, [key]: v})}/>
            }
            {type === 'textarea' &&
              <Textarea placeholder={'text'}
                value={(value[key]||'')+''}
                on_change={v=>handle_change(key, v)} />
            }
            {type === 'number' &&
              <Text_input
                value={(value[key]||'')+''}
                on_change={v=>handle_change(key, +v|0)} />
            }
            {type === 'boolean' &&
              <Checkbox size="xs" mode="toggle" light
                checked={!!value[key]}
                on_change={v=>handle_change(key, v)} />
            }
            {type === 'color' &&
              <Fragment>
                <input type="color"
                onChange={v=>handle_change(key, v.target.value)} />
                <Button caption={'Remove bg'}
                  on_click={()=>handle_change(key, 'transparent')}
                  color="primary"/>
              </Fragment>
            }
            {type === 'selector' &&
              <select
                value={String(value[key] || '')}
                onChange={e=>handle_change(key, e.target.value)}>
                {options?.map(option=>
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                )}
              </select>
            }
          </div>
        )}
        {props.children}
      </div>
      <div className={styles.buttons_container}>
        {on_remove && <Button caption={'Remove'} size={'xs'}
          color='secondary'
          on_click={()=>props.on_remove(value)}/>}
        {on_save && <Button caption={'Save'} size={'xs'}
          on_click={()=>props.on_save()}/>}
        {on_cancel && <Button caption={'Cancel'} size={'xs'}
          color='secondary'
          on_click={()=>props.on_cancel()}/>}
      </div>
    </div>;
};
